import type { GuardrailEntry } from '@/services/guardrailsApi';

interface GuardrailEntryViewProps {
  entry: GuardrailEntry;
}

export function GuardrailEntryView({ entry }: GuardrailEntryViewProps) {
  return (
    <>
      <p className="text-sm text-slate-600 dark:text-slate-400">{entry.description}</p>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <p className="text-[10px] font-medium text-slate-500 uppercase mb-1">
            Bad Pattern
          </p>
          <code className="block text-xs bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 rounded px-2 py-1.5 whitespace-pre-wrap">
            {entry.pattern}
          </code>
        </div>
        <div>
          <p className="text-[10px] font-medium text-slate-500 uppercase mb-1">
            Correct Approach
          </p>
          <code className="block text-xs bg-emerald-50 dark:bg-emerald-900/20 text-emerald-700 dark:text-emerald-300 rounded px-2 py-1.5 whitespace-pre-wrap">
            {entry.fix}
          </code>
        </div>
      </div>

      <div>
        <p className="text-[10px] font-medium text-slate-500 uppercase mb-1">
          Architecture Fitness Test
        </p>
        <code className="block text-xs bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 rounded px-2 py-1.5 whitespace-pre-wrap font-mono">
          {entry.fitnessTest}
        </code>
      </div>
    </>
  );
}
